import * as React from 'react';
import { mailAppCommandBarProps } from '../mailAppCommandBarProps';
import { AppCommandBar } from 'owa-app-commandbar';

export default function MailRibbon() {
    return <AppCommandBar {...mailAppCommandBarProps} />;
}
